@if (source) {
<section class="channels">
  @for (channel of channels | slice : 0 : (expand ? undefined : threshold); track identifyChannel($index, channel)) {
  <bau365-channel-list-item
    [news]="channel.news"
    [active]="source.feed === 'SUBSCRIPTION' && source.channel === channel.id"
    [text]="channel.name"
    (selectChannel)="onSelectChannel(channel)"></bau365-channel-list-item>
  } @if (addChannelsLink && addChannelsText) {
  <a class="add-channels-link" [routerLink]="addChannelsLink">
    <mat-icon>control_point_duplicate</mat-icon>
    {{ addChannelsText }}
  </a>
  } @if (channels ? channels.length > threshold : false) {
  <button class="channels__expand" (click)="expand = !expand">
    <mat-icon>{{ expand ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
    {{ expand ? expandLess : expandMore }}
  </button>
  }
</section>
}
